





































import { Vue, Component } from "@/shared/vuepack";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";
import FormDownload from "@/employee/components/onboarding/balance-transfer/FormDownload.vue";

@Component({
  components: {
    Button,
    FormDownload
  }
})
export default class TrusteeToTrusteeTransferFormDownload extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  generateForm () {
    return this.balanceTransferStore.generateTrusteeToTrusteeBalanceTransferForm();
  }

  goToNextStep () {
    this.balanceTransferStore.goToStep("trustee-finish");
  }

  goToPreviousStep () {
    this.balanceTransferStore.goToStep("trustee-details");
  }
}
